// extracted by mini-css-extract-plugin
export var box = "ErrorModal-module--box--ff50f";
export var box_md = "ErrorModal-module--box_md--be741";
export var box_xmd = "ErrorModal-module--box_xmd--f0b98";
export var box_flex = "ErrorModal-module--box_flex--4980a";
export var box_lg = "ErrorModal-module--box_lg--ac18a";
export var box_sm = "ErrorModal-module--box_sm--c93b2";
export var box_outer = "ErrorModal-module--box_outer--75555";
export var box_whiteBg = "ErrorModal-module--box_white-bg--c3543";
export var box_noMarginBottom = "ErrorModal-module--box_no-margin-bottom--e9741";
export var box_noPadding = "ErrorModal-module--box_no-padding--3ff24";
export var box_outerGray = "ErrorModal-module--box_outer-gray--dd48a";
export var box_dark = "ErrorModal-module--box_dark--fc802";
export var box_zIndex = "ErrorModal-module--box_z-index--46899";
export var box_zIndex6 = "ErrorModal-module--box_z-index-6--9e0ab";
export var box_eventsWithLine = "ErrorModal-module--box_events-with-line--8a0c5";
export var box_featuresAo = "ErrorModal-module--box_features-ao--ffbe9";
export var box_verticalPaddings = "ErrorModal-module--box_vertical-paddings--f60c0";
export var clearP = "ErrorModal-module--clearP--c5164";
export var clearP_vc = "ErrorModal-module--clearP_vc--553db";
export var wrapper = "ErrorModal-module--wrapper--c0e9a";
export var text = "ErrorModal-module--text--eb237";
export var contact = "ErrorModal-module--contact--45091";
export var link = "ErrorModal-module--link--ab27e";
export var icon = "ErrorModal-module--icon--a7cb3";
export var fadeInAnimation = "ErrorModal-module--fadeInAnimation--46475";
export var placeHolderShimmer = "ErrorModal-module--placeHolderShimmer--64197";